import React from 'react';
import { ResponsiveCalendar } from '@nivo/calendar';
import { ToolTip, ToolTipTitle, ToolTipPrimary } from './Line';

const Calendar = (props) => {
  const { data, currentYear } = props;
  /* Multi year > https://codesandbox.io/s/34mqv39kq1?file=/src/index.js:251-254 */


  return (
    <ResponsiveCalendar
      data={data}
      margin={{ top: 24, right: 16, bottom: 16, left: 32 }}
      to={`${currentYear}-12-31`}
      from={`${currentYear}-01-01`}
      colors={['#a3be8c']}
      emptyColor="#eceff4"
      monthBorderColor="#fff"
      dayBorderWidth={2}
      dayBorderColor="#fff"
      theme={{
        fontFamily: 'inherit',
        fontSize: 12,
        axis: {
          ticks: {
            text: {
              fill: "#434c5e"
            }
          },
        },
        tooltip: {
          container: {
            background: '#eceff4',
            borderRadius: '0',
            padding: '0px'
          },
          tableCell: {
            padding: '0px'
          },
        },
      }}
      tooltip={({ day, value }) => (
        <ToolTip>
          <ToolTipTitle>{value}</ToolTipTitle>
          <ToolTipPrimary>{new Date(day).toLocaleDateString()}</ToolTipPrimary>
        </ToolTip>
      )}
    />
  );
};

export default Calendar;